const serviceTypeLabels = {
  installation: {
    key: 'Instalación',
    label: 'Instalação'
  },
  maintenance: {
    key: 'Mantenimiento',
    label: 'Manutenção'
  },
  repair: {
    key: 'Reparación',
    label: 'Reparação'
  },
  homeProgram: {
    key: 'Home Program',
    label: 'Programa Residencial'
  },
  workshopRepairs: {
    key: 'Reparaciones en Taller',
    label: 'Reparos em Oficina'
  },
  deliveries: {
    key: 'Entregas/Despachos',
    label: 'Entregas/Despachos'
  },
  maintenancePolicy: {
    key: 'Póliza de Mantenimiento',
    label: 'Póliza de Manutenção'
  }
}

export default serviceTypeLabels
